import { render, staticRenderFns } from "./cwzdbj.vue?vue&type=template&id=ce718870&scoped=true&"
import script from "./cwzdbj.vue?vue&type=script&lang=js&"
export * from "./cwzdbj.vue?vue&type=script&lang=js&"
import style0 from "./cwzdbj.vue?vue&type=style&index=0&id=ce718870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce718870",
  null
  
)

export default component.exports